/**
 * STEP 4 — Central magasin badge. Reads color + name dynamically from the
 * PermissionsContext (which fetches /api/magasins). Falls back to neutral
 * grey when the code is unknown or null (= neutral cart line).
 */
import React from 'react';

import { usePermissions } from '../contexts/PermissionsContext';

export const MagasinBadge = ({ code, size = 'sm', showName = false, className = '' }) => {
  const { getMagasinColor, getMagasinName } = usePermissions();

  const isNeutral = !code;
  const color = getMagasinColor(code);
  const label = isNeutral ? 'neutre' : code;
  const fullName = isNeutral ? '' : getMagasinName(code);

  const padding = size === 'lg'
    ? 'px-3 py-1 text-sm'
    : size === 'md'
      ? 'px-2.5 py-0.5 text-xs'
      : 'px-2 py-0.5 text-[10px]';

  return (
    <span
      data-testid={`magasin-badge-${code || 'neutre'}`}
      className={`inline-flex items-center gap-1 font-bold uppercase rounded-md border ${padding} ${className}`}
      style={{
        color,
        borderColor: `${color}80`,
        backgroundColor: `${color}1A`, // 10% alpha
      }}
      title={fullName ? `${code} — ${fullName}` : 'Article neutre'}
    >
      {label}
      {showName && fullName ? <span className="ml-1 normal-case font-normal opacity-80">— {fullName}</span> : null}
    </span>
  );
};

export default MagasinBadge;
